import {Component, OnChanges, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomainService} from '../../services/domain.service';
import {Location} from '@angular/common';
import {TopLevelDomain} from '@iana-rzms/bff-sdk';

@Component({
    selector: 'lib-view-domain',
    templateUrl: './view-domain.component.html',
    styleUrls: ['./view-domain.component.scss'],
    standalone: false
})
export class ViewDomainComponent implements OnChanges, OnInit {

  domain: TopLevelDomain;

  domainId: string;

  constructor(private activateRoute: ActivatedRoute,
              private location: Location,
              private domainService: DomainService) {
  }

  ngOnInit(): void {
    this.activateRoute.params.subscribe(data => {
      this.domainId = data['domainId'];
    });
    this.getInputData();
  }

  private getInputData() {
    this.domainService.getDomainByID(this.domainId).subscribe(data => {
      this.domain = data;
    }, () => {
    }, () => {
    });
  }

  ngOnChanges(changes: any): void {
  }


  back() {
    this.location.back();
  }
}
